import { Close, Save } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import ArgonBox from 'components/ArgonBox';
import ArgonButton from 'components/ArgonButton';
import ArgonInput from 'components/ArgonInput';
import ArgonTypography from 'components/ArgonTypography';
import { postSubmit } from 'global/postFunc';
import React, { useEffect, useState } from 'react'

const EditData = ({
    data,
    open,
    handleClose,
    addReq,
    decryptedUser,
    updating,
    setUpdating
}) => {
    const [saving, setSaving] = useState(false)

    const [prevUsername, setPrevUsername] = useState('')
    const [username, setUsername] = useState('')
    const [nama, setNama] = useState('')
    const [nip, setNip] = useState('')
    const [password, setPassword] = useState('')

    useEffect(() => {
        if (open) {
            console.log(data);
            setPrevUsername(data.username || '')
            setUsername(data.username || '')
            setNama(data.nama || '')
            setNip(data.nip || '')
            setPassword(data.password || '')
            setSaving(false)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const submit = (e) => {
        const formData = {
            _method: 'PUT',
            kd_pd: data.kd_pd,
            nip: nip,
            nama: nama,
            username: username,
            password: password,
            prevUsername: prevUsername
        }
        
        addReq()
        e.preventDefault();
        setSaving(true)
        postSubmit(
            '/sa/users/admin-opd-update',
            formData,
            decryptedUser,
            (res) => {
                setSaving(false)
                handleClose()
                setUpdating(!updating)
            },
            (res) => {
                setSaving(false)
                handleClose()
            }
        )
    }

    return (
        <Dialog
            open={open}
            maxWidth="md"
            fullWidth
            // scroll='paper'
            p={3}
            component='form'
            onSubmit={submit}
        >
            <DialogTitle>
                <ArgonTypography variant='body2' fontWeight="bold">Edit Admin OPD</ArgonTypography>
            </DialogTitle>
            <DialogContent p={3}>
                <ArgonBox mb={1}>
                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                        Admin {data.nama_pd}
                    </ArgonTypography>
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Nama
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        type="text"
                        required
                        size="medium"
                        value={nama}
                        onChange={(e) => setNama(e.target.value)}
                        autoComplete='off'
                    />
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            NIP
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        type="text"
                        required
                        size="medium"
                        value={nip}
                        onChange={(e) => setNip(e.target.value)}
                        autoComplete='off'
                    />
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Username
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        type="text"
                        required
                        size="medium"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        autoComplete='off'
                    />
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Password
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        type="text"
                        required
                        size="medium"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete='off'
                    />
                </ArgonBox>
            </DialogContent>
            <DialogActions>
                <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                    <Grid item>
                        <ArgonButton color='info' variant='outlined' size="small" startIcon={<Close />} onClick={handleClose}>Batal</ArgonButton>
                    </Grid>
                    <Grid item>
                        <LoadingButton color='info' variant='contained' size="small" startIcon={<Save />} type='submit' loading={saving}>Simpan</LoadingButton>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default EditData